const storageGet = (key, type = 'sessionStorage') => {
  try {
    return JSON.parse(window[type].getItem(key))
  } catch (e) {
    console.log(e)
  }
}

const storageSet = (key, val, type = 'sessionStorage') => window[type].setItem(key, JSON.stringify(val))

const storageRemove = (key, type = 'sessionStorage') => window[type].removeItem(key)

export const getSession = key => storageGet(key)
export const setSession = (key, val) => storageSet(key, val)
export const removeSession = key => storageRemove(key)

export const getLocal = key => storageGet(key, 'localStorage')
export const setLocal = (key, val) => storageSet(key, val, 'localStorage')
export const removeLocal = key => storageRemove(key, 'localStorage')
// TODO: 服务添加状态判断时删除
export const clearStorageExcept = function(exceptions, isAll) {
  let keys = [];
  const defaultKeys = isAll ? [] :['report_local', 'merchantId'] // 默认不清除
  exceptions = defaultKeys.concat(exceptions);
  // TODO 过滤merchantId的清理，都不做清理，

  keys = [...Object.keys(localStorage)]
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i];
    let deleteItem = true;
    for (let j = 0; j < exceptions.length; j++) {
      let exception = exceptions[j];
      if (key.includes(exception)) {
        deleteItem = false;
      }
    }
    if (deleteItem) {
      localStorage.removeItem(key);
    }
  }
};
/**
 * localStorage
 * @调用：_local.set('access_token', '123456', 5000);
 * @调用：_local.get('access_token');
 */

const _local = {
  // 存储,可设置过期时间
  set (key, value, expires) {
    const params = { key, value, expires }
     // TODO： 特殊处理merchantId
     let userId = this.get('userId')
     if (params.key == 'merchantId' && userId) {
      params.key = `${key}_${userId}`
      key = `${key}_${userId}`
    }
    if (expires) {
      // 记录何时将值存入缓存，毫秒级
      var data = Object.assign(params, { startTime: new Date().getTime() })
      localStorage.setItem(key, JSON.stringify(data))
    } else {
      if (Object.prototype.toString.call(value) === '[object Object]' || Object.prototype.toString.call(value) === '[object Array]') {
        value = JSON.stringify(value)
      }
      localStorage.setItem(key, value)
    }
  },
  // 取出
  get (key) {
    // TODO： 特殊处理merchantId
    if (key == 'merchantId') {
      let userId = this.get('userId')
      key = `${key}_${userId}`
    }
    let item = localStorage.getItem(key)
    // 先将拿到的试着进行json转为对象的形式
    try {
      item = JSON.parse(item)
    } catch (error) {
      // eslint-disable-next-line no-self-assign
      item = item
    }
    // 如果有startTime的值，说明设置了失效时间
    if (item && item.startTime) {
      const date = new Date().getTime()
      // 如果大于就是过期了，如果小于或等于就还没过期
      if (date - item.startTime > item.expires) {
        localStorage.removeItem(name)
        return false
      } else {
        return item.value
      }
      
    } else {
      return item
    }
  },
  // 删除
  remove (key) {
    localStorage.removeItem(key)
  },
  // 清除全部
  clear () {
    localStorage.clear()
  }
}

/**
 * sessionStorage
 */
const _session = {
  get: function (key) {
    var data = sessionStorage[key]
    if (!data || data === 'null') {
      return null
    }
    return JSON.parse(data).value
  },
  set: function (key, value) {
    var data = {
      value: value
    }
    sessionStorage[key] = JSON.stringify(data)
  },
  // 删除
  remove (key) {
    sessionStorage.removeItem(key)
  },
  // 清除全部
  clear () {
    sessionStorage.clear()
  }
}
export { _local, _session }
